import React, { useState, useEffect } from "react";
import DataTable from "../../components/DataTable";
import SnackbarAlert from "../../components/SnackbarAlert";
import { Box, TextField, Tooltip, Typography, Button, CircularProgress, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { webEndPoint } from '../../constants/globalConstants';
import { makeRequest } from "../../services/api";
export default function AgeMasterPage() {
    const [datasource, setDatasource] = useState([]);
    const [search, setSearch] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [editState, setEditState] = useState(null);
    const [ageName, setAgeName] = useState("");
    const [snackbar, setSnackbar] = useState(false);
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        fetchages();
    }, []);
    const fetchages = async () => {
        setLoading(true);
        try {
            let url = webEndPoint + "ages";
            const response = await makeRequest("get", url);
            if (response) {
                setDatasource(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const openAddModal = () => {
        setEditState(null);
        setAgeName("");
        setOpenModal(true);
    };
    const handleEdit = (state) => {
        setEditState(state);
        setAgeName(state.age_name);
        setOpenModal(true);
    };
    const handleClose = () => {
        setOpenModal(false);
        setAgeName("");
    };
    const handleSave = async () => {
        if (!ageName.trim()) {
            setMessage("Age Name Required");
            setSnackbar(true);
            return;
        }
        setLoading(true);
        try {
            if (editState) {
                const stateEditData = {
                    age_name: ageName,
                    image_url: ""
                };
                try {
                    let url = webEndPoint + "ages/" + editState.rfId;
                    const response = await makeRequest("put", url, stateEditData);
                    if (response) {
                        setLoading(false);
                        setMessage("Age Updated Successfully");
                    }
                } catch (err) {
                    if (err?.message) {
                        setMessage(err.message);
                    } else {
                        setMessage("Something went wrong");
                    }
                } finally {
                    setLoading(false);
                }
            } else {
                const ageAddData = {
                    age_name: ageName,
                    image_url: ""
                };
                try {
                    let url = webEndPoint + "ages";
                    const response = await makeRequest("post", url, ageAddData);
                    if (response) {
                        setLoading(false);
                        setMessage("Age Added Successfully");
                    }
                } catch (err) {
                    if (err?.message) {
                        setMessage(err.message);
                    } else {
                        setMessage("Something went wrong");
                    }
                } finally {
                    setLoading(false);
                }
            }
            fetchages();
            setSnackbar(true);
            setOpenModal(false);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const filteredState = datasource?.filter((d) =>
        d?.age_name?.toLowerCase().includes(search?.toLowerCase())
    );
    const columns = ["S.No", "Age", "Action"];
    const rows = filteredState?.map((district, index) => [index + 1, district.age_name,
    <Box>
        <Tooltip title="Edit Age Category">
            <Button variant="contained" color="primary" onClick={() => handleEdit(district)}>Edit</Button>
        </Tooltip>
    </Box>
    ]);
    return (
        <Box sx={{ position: "relative" }}>
            {loading && (
                <Box sx={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", backgroundColor: "rgba(255,255,255,0.6)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999, }}>
                    <CircularProgress />
                </Box>
            )}
            <Typography variant="h6" sx={{ mb: 3, fontWeight: 500 }}>Age Category Master</Typography>
            <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 2, alignItems: { xs: "stretch", sm: "center" }, justifyContent: "space-between", mb: 2, width: "100%", }}>
                <TextField label="Search Age" size="small" value={search} onChange={(e) => setSearch(e.target.value)} sx={{ width: { xs: "100%", sm: "70%", md: 600 } }} />
                <Button variant="contained" startIcon={<AddIcon />} onClick={openAddModal} sx={{ width: { xs: "100%", sm: "auto" }, }}>Add Age Category</Button>
            </Box>
            <DataTable columns={columns} rows={rows} />
            <SnackbarAlert open={snackbar} setOpen={setSnackbar} message={message} />
            <Dialog open={openModal} onClose={handleClose} fullWidth maxWidth="sm">
                <DialogTitle> {editState ? "Edit Age Category" : "Add Age Category"}</DialogTitle>
                <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
                    <TextField label="Age Category" value={ageName} onChange={(e) => setAgeName(e.target.value)} sx={{ mt: 2 }} fullWidth />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button variant="contained" onClick={handleSave}>Save</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}